<mat-form-field appearance="outline">
  <input matInput type="text" [formControl]="myControl" [matAutocomplete]="autoProduct" [readonly]="readOnly"
    (input)="onInput()" class="product-search" placeholder="Concepto">
  <mat-autocomplete #autoProduct="matAutocomplete" (optionSelected)="productSelected($event.option.value)">
    <ng-container *ngFor="let product of $products | async">
      <mat-option [value]="product">
        {{product?.name}} {{product?.price | money : { needSymbol:true } }}
        <span *ngIf="product?.category?.name">
          ({{ product?.category?.name }})
        </span>
      </mat-option>
    </ng-container>
    <mat-option [value]="null" class="always-visible-option">
      <button type="button" class="btn btn-link text-manax mx-1 p-1" (click)="openNewProductModal()"
        style="text-transform: capitalize;">
        Agregar Producto / Servicio <i class="material-icons">add</i>
      </button>
    </mat-option>
  </mat-autocomplete>
  <!--
  <mat-error *ngIf="myControl.hasError('maxlength')">
    Las conceptos deben tener un largo menor a 50 caracteres
  </mat-error>
  -->
</mat-form-field>